<template>
  <CMasonryLayout
    v-if="products.length"
    :data="products"
    :columns-count="finalColumnsCount"
    class="products-list"
  >
    <template #default="{ item }">
      <RouterLink
        :to="getProductLink(item)"
        class="product-card-link"
      >
        <CatalogProductCard :product="item" />
      </RouterLink>
    </template>
  </CMasonryLayout>

  <div v-else-if="isLoading">
    <CPreloader />
  </div>

  <div
    v-else
    class="products-list-empty"
  >
    {{ emptyStateText }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { Product } from '@/services/product/types';

  import CatalogProductCard from '../CatalogProductCard/CatalogProductCard.vue';

  import CMasonryLayout from '../layout/CMasonryLayout.vue';
  import CPreloader from '../CPreloader/CPreloader.vue';
  import { useClientSize } from '@/composables/useClientSize';

  const props = withDefaults(
    defineProps<{
      isLoading?: boolean;
      products: Product[];
      emptyStateText?: string;
      linkFromParam?: 'machine' | 'main-page';
      linkFromValue?: string | number;
      columnsCount?: number;
    }>(),
    {
      emptyStateText: 'Товаров нет'
    }
  );

  const { isMobile } = useClientSize();

  const finalColumnsCount = computed(() => (isMobile.value ? 1 : props.columnsCount || 5));

  function getProductLink(product: Product) {
    let link = `/product/${product.id}`;

    const params = [
      {
        key: 'from',
        value: props.linkFromParam
      },
      {
        key: 'from-value',
        value: props.linkFromValue
      }
    ].filter(param => param.value);

    params.forEach((param, index) => {
      link += `${index === 0 ? '?' : '&'}${param.key}=${param.value}`;
    });

    return link;
  }
</script>

<style>
  .product-card-link {
    text-decoration: none;
  }

  .products-list-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    margin: 36px 0 12px;
  }
</style>
